import React, { useEffect } from 'react'
import { CALENDAR_LEGENDS } from '@layers-frontend/commons/constants'
import { panelSelectSx } from '../../theme'
import withTranslator from '../HOCComponents/withTranslator'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import styled from 'styled-components'
import StyledSelect from '../UIComponents/StyledSelect'
import find from 'lodash/find'
import map from 'lodash/map'
import filter from 'lodash/filter'
import first from 'lodash/first'
import some from 'lodash/some'
import { Dot } from '../FieldsComponents/SelectedFieldsCalendarLegendItem'

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 15px;
`

const InputValue = styled.div`
  margin-left: 10px;
`

// The select's own underline is the separator above the layer list; this 1px stays transparent so nothing moves.
const wrapperStyle = {
  borderBottom: `1px solid ${themeColors.transparent}`
}

const DeliverablesSourceSelector = ({ t, activeDateCalendarDots, selectFlightGroup, selectedFlightGroupIndex, cloudCoverage }) => {
  // Filter sources to only show those that meet the cloud coverage filter
  const filteredCalendarDots = filter(activeDateCalendarDots, dot => dot.cloudCoverage <= cloudCoverage)

  const options = map(filteredCalendarDots, activeDateCalendarDot => ({
    id: activeDateCalendarDot.index,
    name: CALENDAR_LEGENDS[activeDateCalendarDot.source].name,
    color: activeDateCalendarDot.color
  }))

  // Check if selected source is still available after filtering
  const isSelectedSourceAvailable = some(options, option => option.id === selectedFlightGroupIndex)

  // Auto-select first available source if current selection is filtered out
  useEffect(() => {
    if (!isSelectedSourceAvailable && options.length > 0) {
      const firstAvailableOption = first(options)
      selectFlightGroup(firstAvailableOption.id)
    }
  }, [isSelectedSourceAvailable, options, selectFlightGroup])

  const onChange = value => {
    selectFlightGroup(value)
  }

  // Don't render if less than 2 options available or waiting for auto-selection
  if (options.length <= 1 || !isSelectedSourceAvailable) {
    return null
  }

  return (
    <StyledSelect
      defaultValue={selectedFlightGroupIndex}
      isCalendarSelector
      fullWidth={true}
      value={selectedFlightGroupIndex}
      onChange={onChange}
      options={options}
      wrapperStyle={wrapperStyle}
      sx={panelSelectSx}
      renderValue={value => {
        const activeValue = find(options, item => item.id === value)

        if (!activeValue) {
          return null
        }

        return (
          <InputWrapper>
            <Dot key={activeValue.source} dotColor={activeValue.color} />
            <InputValue>{activeValue.name}</InputValue>
          </InputWrapper>
        )
      }}
    />
  )
}

export default withTranslator(DeliverablesSourceSelector)
